import { render, staticRenderFns } from "./LoadingText.vue?vue&type=template&id=4924466c&scoped=true"
import script from "./LoadingText.vue?vue&type=script&lang=js"
export * from "./LoadingText.vue?vue&type=script&lang=js"
import style0 from "./LoadingText.vue?vue&type=style&index=0&id=4924466c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4924466c",
  null
  
)

export default component.exports